import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Marker, Popup, Tooltip } from 'react-leaflet';
import './MapPin.less';
import useMapMarker from '../hooks/useMapMarker';
import { HotelData } from '../../../modules/HotelDetails/hotelSlice';
import { ClusterGroup, MapMarker, HoverCardData } from '../../../types/map';
import { Tooltip as AntTooltip } from 'antd';
import { LeafletMouseEvent, PointExpression } from 'leaflet';

interface MapPinProps {
  item: MapMarker;
  map: L.Map | null;
  isCluster?: boolean;
  count?: number;
  onHover?: (
    item: MapMarker | null,
    position?: { x: number; y: number }
  ) => void;
  onClick?: (hotel: HotelData) => void;
  renderHoverCard?: (data: HoverCardData) => React.ReactNode;
  priceLabel?: string;
  markerColor?: string;
  renderTooltip?: boolean;
  openPopup?: boolean;
  handleSelectMarker?: (id: string) => void;
  dir?: 'rtl' | 'ltr' | undefined;
}

const MapPin: React.FC<MapPinProps> = ({
  item,
  map,
  isCluster = false,
  count = 0,
  onHover,
  onClick,
  renderHoverCard,
  priceLabel,
  markerColor,
  renderTooltip = true,
  openPopup = false,
  handleSelectMarker,
  dir,
}) => {
  const markerRef = useRef<L.Marker | null>(null);
  const { hotelIcon, createClusterIcon } = useMapMarker({ color: markerColor });
  const icon = isCluster ? createClusterIcon(count) : hotelIcon;
  // const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (openPopup && map && markerRef?.current) {
      timeout = setTimeout(() => {
        const currentZoom = map.getZoom();
        const targetZoom = Math.max(currentZoom, 20); // Don't zoom out, only zoom in if needed
        // Use flyTo instead of flyToBounds for smoother animation
        map.flyTo(item.position, targetZoom, {
          duration: 0.3, // Slower, smoother animation
          // easeLinearity: 0.1, // Smoother easing
        });

        // Open popup after animation completes
        setTimeout(() => {
          markerRef.current && markerRef.current.openPopup();
        }, 1600); // Slightly after animation duration
      }, 100); // Reduced delay
    }
    if (!openPopup && map && markerRef?.current?.isPopupOpen()) {
      markerRef.current?.closePopup();
    }
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openPopup, map]);

  const handleClick = (e: any) => {
    const location = e.target.getLatLng();
    const currentZoom = map?.getZoom() || 10;
    const targetZoom = Math.max(currentZoom, 15);
    // handleSelectMarker?.(item.identifier);
    // map?.flyTo(location, targetZoom, {
    //   duration: 0.3,
    //   // easeLinearity: 0.1,
    // });
  };

  return (
    <Marker
      ref={markerRef}
      icon={icon}
      position={item.position}
      eventHandlers={{
        click(e) {
          handleClick(e);
        },
      }}
    >
      {!!priceLabel && <Tooltip
        direction={'bottom'}
        // offset on x axis has to be its own width, for rtl
        offset={[dir === 'rtl' ? 42 : 0, 1]}
        permanent
      >
        <div className="item-price">
          {priceLabel}
        </div>
      </Tooltip>}
      {renderHoverCard && (
        <Popup
          className="map-hover-card"
          keepInView={false}
          autoPan={false}
          closeOnEscapeKey
          closeOnClick
          autoClose
        >
          {renderHoverCard({ item })}
        </Popup>
      )}
    </Marker>
  );
};

export default MapPin;
